import { render, staticRenderFns } from "./AssetsFavouritesAdmin.vue?vue&type=template&id=410bbbc7&scoped=true"
import script from "./AssetsFavouritesAdmin.vue?vue&type=script&lang=js"
export * from "./AssetsFavouritesAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410bbbc7",
  null
  
)

export default component.exports